import React from 'react';
import { CTAButton } from './CTAButton';
export function Navigation() {
  return <nav className="fixed top-0 left-0 right-0 z-[1000] h-[56px] md:h-[60px] glass-nav flex items-center justify-between px-5 md:px-10" data-id="element-135">
      <img src="https://cdn.magicpatterns.com/uploads/8tRU83W9dxrwe3og2JbRiJ/LOGO_PNG.png" alt="Vitalene" className="h-[32px] md:h-[38px] w-auto" data-id="element-136" />

      <div className="flex items-center gap-3" data-id="element-137">
        <a href="https://vitalenehealth.com" target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex" data-id="element-138">
          <CTAButton variant="primary" className="!py-2.5 !px-5 !text-[13px] !shadow-[0_4px_12px_rgba(230,126,34,0.25)]" data-id="element-139">
            Get Your Showerhead at 20% Off
          </CTAButton>
        </a>
        <button className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-black/5 transition-colors duration-200" aria-label="Shopping cart" data-id="element-140">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="text-gray-800" data-id="element-141">
            <circle cx="8" cy="21" r="1" data-id="element-142" />
            <circle cx="19" cy="21" r="1" data-id="element-143" />
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" data-id="element-144" />
          </svg>
        </button>
      </div>
    </nav>;
}